import { measurementListProps, measurementDropDownListProps } from './properties'

export const setMeasurementMasterList = (state, payload) => {
    state.list = payload
    state.list.forEach(element => {
        if(element.measurement_drop_down_list.length === 0) {
            element.measurement_drop_down_list = [JSON.parse(JSON.stringify(measurementDropDownListProps))]
        } 
    })
}    

export const addNewMeasurementMasterListItemRow = state => {

    let sl_no = 0
    state.list.push(JSON.parse(JSON.stringify(measurementListProps)))

    state.list.forEach(element => {
        element.sl_no = sl_no
        sl_no ++
    })

    setTimeout(() => {
        document.getElementById('measurement_name_'+(sl_no-1)).focus()
    }, 300);

}

export const removeMeasurementMasterListItemRow = (state, payload) => {

    let sl_no = 0

    state.deleted_measurement_list_items.push(state.list[payload])

    state.list.splice(payload, 1)

    if(state.list.length === 0) {
        state.list = [JSON.parse(JSON.stringify(measurementListProps))]
    }

    state.list.forEach(element => {
        element.sl_no = sl_no
        sl_no ++
    })

}

export const sortMeasurementMasterList = (state, payload) => {

    let key = (payload.sl_no)

    if(payload.sort == 1) {
        state.list[key].sl_no = payload.sl_no+1
        state.list[key+1].sl_no = payload.sl_no         
    } else if(payload.sort == 0) {
        state.list[key].sl_no = payload.sl_no-1
        state.list[key-1].sl_no = payload.sl_no         
    }

    state.list = state.list.sort( (a,b) => { 
        var x = a.sl_no < b.sl_no? -1:1; 
        return x; 
    });

}

export const addNewMeasurementMasterListDropDownItemRow = (state, parent_key) => {

    let key = 0
    state.list[parent_key].measurement_drop_down_list.push(JSON.parse(JSON.stringify(measurementDropDownListProps)))

    state.list[parent_key].measurement_drop_down_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('measurement_value_'+(key-1)).focus()
    }, 300);

}

export const removeMeasurementMasterListDropDownItemRow = (state, payload) => {

    let key = 0

    state.list[payload.parent_key].deleted_measurement_drop_down_list_items.push(state.list[payload.parent_key].measurement_drop_down_list[payload.key])

    state.list[payload.parent_key].measurement_drop_down_list.splice(payload.key, 1)

    if(state.list[payload.parent_key].measurement_drop_down_list.length === 0) {
        state.list[payload.parent_key].measurement_drop_down_list = [JSON.parse(JSON.stringify(measurementDropDownListProps))]
    }

    state.list[payload.parent_key].measurement_drop_down_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetMeasurementMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementMaster/mutations.js